module.exports = __webpack_public_path__ + "media/images/lb/895-91623c4afc4b6da146756c5e9038ab9b.svg";